var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState, } from "react";
import { Box, VStack, HStack, FormControl, FormLabel, Input, Flex, Button, Select, useToast, } from "@reverb-ui/react";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { useForm, useWatch, Controller } from "react-hook-form";
import { LocationContext, LocationProvider, } from "@/shared/presentation/context-api/providers/location";
import { makeUtilDatasource } from "@/main/factories/datasources/util-datasource-factory";
import { CompanyWizardContext } from "@/features/first-access/presentation/context-api/company-wizard-provider";
import { UtilContext } from "@/shared/presentation/context-api/providers/util";
export var CompanyAddressForm = function (_a) {
    var _b, _c;
    var hasNextStep = _a.hasNextStep, hasPreviousStep = _a.hasPreviousStep, goToNextStep = _a.goToNextStep, goToPrevStep = _a.goToPrevStep, setAddedAddress = _a.setAddedAddress, defaultValues = _a.defaultValues;
    var _d = useForm({
        defaultValues: defaultValues,
    }), register = _d.register, control = _d.control, handleSubmit = _d.handleSubmit, setValue = _d.setValue;
    var addCompanyAddress = useContext(CompanyWizardContext).addCompanyAddress;
    var _e = useState(false), creatingCompanyAddress = _e[0], setCreatingCompanyAddress = _e[1];
    var _f = useState(false), formFieldsDisabled = _f[0], setFormFieldsDisabled = _f[1];
    var formState = useWatch({ control: control });
    var toast = useToast();
    var submit = function (values) {
        setCreatingCompanyAddress(true);
        if (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id) {
            goToNextStep();
            return;
        }
        addCompanyAddress({
            zipCode: values.zipCode,
            cityId: values.cityId.value,
            countryId: values.countryId.value,
            stateId: values.stateId.value,
            neighborhood: values.neighborhood,
            street: values.street,
            number: values.addressNumber,
            complement: values.complement,
            typeId: values.typeId.value,
        })
            .then(function (response) {
            setAddedAddress(response);
            goToNextStep();
        })
            .catch(function (e) {
            return toast({
                status: "error",
                title: e.message,
                duration: 3000,
            });
        })
            .finally(function () { return setCreatingCompanyAddress(false); });
    };
    var addressTypes = useContext(UtilContext).addressTypes;
    var onSuggestionLoads = function (address) {
        setValue("cityId", {
            value: address.suggestedCity.id,
            label: address.suggestedCity.description,
        });
        setValue("stateId", {
            value: address.suggestedState.id,
            label: address.suggestedState.description,
        });
        setValue("neighborhood", address.suggestedNeighborhood);
        setValue("street", address.suggestedStreet);
    };
    useEffect(function () {
        if (defaultValues === null || defaultValues === void 0 ? void 0 : defaultValues.id) {
            setFormFieldsDisabled(true);
        }
    }, [defaultValues]);
    return (React.createElement(LocationProvider, { utilRepository: makeUtilDatasource(), currentCountryId: (_b = formState === null || formState === void 0 ? void 0 : formState.countryId) === null || _b === void 0 ? void 0 : _b.value, currentStateId: (_c = formState === null || formState === void 0 ? void 0 : formState.stateId) === null || _c === void 0 ? void 0 : _c.value, zipCode: formState === null || formState === void 0 ? void 0 : formState.zipCode, onSuggestionLoads: onSuggestionLoads },
        React.createElement(LocationContext.Consumer, null, function (_a) {
            var cities = _a.cities, countries = _a.countries, states = _a.states;
            return (React.createElement(Box, { w: "full" },
                React.createElement("form", null,
                    React.createElement(VStack, { spacing: 8 },
                        React.createElement(HStack, { w: "full", spacing: 5 },
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Address type"),
                                React.createElement(Controller, { name: "typeId", control: control, rules: { required: true }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Select, __assign({}, field, { isDisabled: formFieldsDisabled, options: addressTypes.map(function (_a) {
                                                var id = _a.id, description = _a.description;
                                                return ({
                                                    value: id,
                                                    label: description,
                                                });
                                            }) })));
                                    } })),
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Country"),
                                React.createElement(Controller, { name: "countryId", control: control, rules: { required: true }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Select, __assign({}, field, { isDisabled: formFieldsDisabled, options: countries.map(function (_a) {
                                                var id = _a.id, description = _a.description;
                                                return ({
                                                    value: id,
                                                    label: description,
                                                });
                                            }) })));
                                    } })),
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Zip/Post code"),
                                React.createElement(Input, __assign({ isDisabled: formFieldsDisabled }, register("zipCode", { required: true })))),
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "State"),
                                React.createElement(Controller, { name: "stateId", control: control, rules: { required: true }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Select, __assign({}, field, { isDisabled: formFieldsDisabled, options: states.map(function (_a) {
                                                var id = _a.id, description = _a.description;
                                                return ({
                                                    value: id,
                                                    label: description,
                                                });
                                            }) })));
                                    } }))),
                        React.createElement(HStack, { w: "full", spacing: 5 },
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "City"),
                                React.createElement(Controller, { name: "cityId", control: control, rules: { required: true }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(Select, __assign({}, field, { isDisabled: formFieldsDisabled, options: cities.map(function (_a) {
                                                var id = _a.id, description = _a.description;
                                                return ({
                                                    value: id,
                                                    label: description,
                                                });
                                            }) })));
                                    } })),
                            React.createElement(FormControl, { isRequired: true },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Neighborhood"),
                                React.createElement(Input, __assign({ isDisabled: formFieldsDisabled }, register("neighborhood", { required: true }))))),
                        React.createElement(HStack, { w: "full", spacing: 5 },
                            React.createElement(FormControl, { isRequired: true, flex: 1 },
                                React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Street"),
                                React.createElement(Input, __assign({ isDisabled: formFieldsDisabled }, register("street", { required: true })))),
                            React.createElement(HStack, { flex: 1, spacing: 5 },
                                React.createElement(FormControl, { isRequired: true },
                                    React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Number"),
                                    React.createElement(Input, __assign({ isDisabled: formFieldsDisabled }, register("addressNumber", { required: true })))),
                                React.createElement(FormControl, null,
                                    React.createElement(FormLabel, { fontSize: "sm" }, "Complement"),
                                    React.createElement(Input, __assign({ isDisabled: formFieldsDisabled }, register("complement")))))))),
                React.createElement(Flex, { justifyContent: "space-between", pt: 8, pb: 3 },
                    React.createElement(Box, null, hasPreviousStep && (React.createElement(Button, { colorScheme: "blue", onClick: goToPrevStep }, "Previous"))),
                    React.createElement(HStack, { spacing: 3 },
                        React.createElement(Button, { variant: "outline", onClick: goToNextStep, isDisabled: creatingCompanyAddress }, "Skip"),
                        hasNextStep && (React.createElement(Button, { colorScheme: "blue", isDisabled: creatingCompanyAddress, onClick: handleSubmit(submit) }, "Next"))))));
        })));
};
